import type { ReactNode } from "react";

import type {
  TCalendarSingleProps,
} from "@/ui/components/form/Calendar/Calendar.config";
import type { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const CALENDAR_PREVIEW_CLASS_MAP = {
  root: "w-full",
  header: "w-full",
  panel: "grid w-full transition-[grid-template-rows] duration-300 ease-in-out motion-reduce:transition-none",
  panelClosed: "grid-rows-[0fr]",
  panelOpen: "grid-rows-[1fr]",
  content: "min-h-0 overflow-hidden transition-opacity duration-300 ease-in-out motion-reduce:transition-none",
  contentClosed: "opacity-0",
  contentOpen: "opacity-100",
  calendar: "pt-4",
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TCalendarPreviewProps = {
  calendar: Omit<TCalendarSingleProps, "mode">;
  closeLabel?: ReactNode;
  date: ReactNode;
  defaultOpen?: boolean;
  editLabel?: ReactNode;
  id?: string;
  title?: ReactNode;
  hideDatePreview?: boolean;
};

export type TCalendarPreviewHeaderProps = Required<Pick<
  TCalendarPreviewProps,
  "date" | "title"
>>;

export type TCalendarPreviewPanelProps = Pick<
  TCalendarPreviewProps,
  "calendar"
> & {
  id: string;
  isOpen: boolean;
};

type TCalendarPreviewDefaultProps = DefinedDefaults<
  TCalendarPreviewProps,
  "closeLabel" | "defaultOpen" | "editLabel" | "title"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const CALENDAR_PREVIEW_DEFAULTS = {
  closeLabel: "Close calendar",
  defaultOpen: false,
  editLabel: "Edit date",
  title: "Date",
} satisfies TCalendarPreviewDefaultProps;
